<template>
  <button
    class="flex items-center justify-center py-2 px-3 font-semibold transition-colors focus:ring focus-visible:outline-none"
    :class="buttonConfig[buttonTheme][type]"
    :disabled="disabled"
  >
    <div v-if="$slots.iconLeft || loading" class="mr-2">
      <slot name="iconLeft"></slot>
      <IconSpin v-if="loading" class="h-5 w-5 animate-spin" />
    </div>
    <span class="first-letter:uppercase">
      <slot></slot>
    </span>
    <div v-if="$slots.iconRight" class="ml-2">
      <slot name="iconRight"></slot>
    </div>
  </button>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'
import IconSpin from '~/assets/icon/general/Spin.svg'

const props = defineProps({
  plain: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String as PropType<ButtonType>,
    default: 'primary',
  },
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const buttonTheme = computed<string>(() => {
  if (props.plain) return 'plain'
  return 'default'
})

const buttonConfig: Record<string, Record<ButtonType, string>> = {
  plain: {
    primary:
      'border border-shade-200 text-shade-900 hover:border-shade-100 focus:border-transparent focus:ring-primary-400 disabled:text-shade-200',
    danger:
      'disabled:status-invalid-alpha-400 border border-status-invalid-400 text-status-invalid-400 hover:border-status-invalid-300 hover:text-status-invalid-300 focus:border-transparent focus:ring-status-invalid-400',
  },
  default: {
    thesaurus: 'bg-black text-white',
    primary:
      'bg-primary-400 text-white hover:bg-shade-900 focus:ring-primary-alpha-400 disabled:bg-primary-alpha-400',
    danger:
      'bg-status-invalid-400 text-white hover:bg-shade-900 focus:ring-status-invalid-alpha-400 disabled:bg-status-invalid-alpha-400',
  },
}
</script>
